export default "__VITE_ASSET__C_4T4LnO__"